export default __webpack_public_path__ + "static/media/img5.ebbd3690.png";